var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepingFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 246 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_397_3120)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iii_397_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 115C0 51.4872 51.4873 0 115 0H127C192.722 0 246 53.2781 246 119V127C246 192.722 192.722 246 127 246H123C55.069 246 0 190.931 0 123V115Z",
    fill: "url(#paint0_radial_397_3120)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_397_3120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 132.5,
    r: 35.5,
    fill: "#FF4242"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_397_3120)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188.5,
    cy: 132.5,
    r: 35.5,
    fill: "#FF4242"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_397_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.54 97C105.66 97 109.081 100.378 108.197 104.402C106.794 110.789 103.591 116.699 98.8952 121.395C92.4252 127.865 83.65 131.5 74.5 131.5C65.35 131.5 56.5748 127.865 50.1048 121.395C45.6509 116.941 42.5406 111.395 41.0346 105.386C39.8974 100.848 43.7924 97 48.4706 97C52.8564 97 56.2631 100.719 58.1273 104.689C59.0089 106.566 60.215 108.296 61.7097 109.79C65.1019 113.182 69.7027 115.088 74.5 115.088C79.2973 115.088 83.8981 113.182 87.2903 109.79C88.5423 108.538 89.5918 107.122 90.4178 105.591C92.7658 101.24 96.5961 97 101.54 97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.54 97C105.66 97 109.081 100.378 108.197 104.402C106.794 110.789 103.591 116.699 98.8952 121.395C92.4252 127.865 83.65 131.5 74.5 131.5C65.35 131.5 56.5748 127.865 50.1048 121.395C45.6509 116.941 42.5406 111.395 41.0346 105.386C39.8974 100.848 43.7924 97 48.4706 97C52.8564 97 56.2631 100.719 58.1273 104.689C59.0089 106.566 60.215 108.296 61.7097 109.79C65.1019 113.182 69.7027 115.088 74.5 115.088C79.2973 115.088 83.8981 113.182 87.2903 109.79C88.5423 108.538 89.5918 107.122 90.4178 105.591C92.7658 101.24 96.5961 97 101.54 97Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_397_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.54 97C202.66 97 206.081 100.378 205.197 104.402C203.794 110.789 200.591 116.699 195.895 121.395C189.425 127.865 180.65 131.5 171.5 131.5C162.35 131.5 153.575 127.865 147.105 121.395C142.651 116.941 139.541 111.395 138.035 105.386C136.897 100.848 140.792 97 145.471 97C149.856 97 153.263 100.719 155.127 104.689C156.009 106.566 157.215 108.296 158.71 109.79C162.102 113.182 166.703 115.088 171.5 115.088C176.297 115.088 180.898 113.182 184.29 109.79C185.542 108.538 186.592 107.122 187.418 105.591C189.766 101.24 193.596 97 198.54 97Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54 97C202.66 97 206.081 100.378 205.197 104.402C203.794 110.789 200.591 116.699 195.895 121.395C189.425 127.865 180.65 131.5 171.5 131.5C162.35 131.5 153.575 127.865 147.105 121.395C142.651 116.941 139.541 111.395 138.035 105.386C136.897 100.848 140.792 97 145.471 97C149.856 97 153.263 100.719 155.127 104.689C156.009 106.566 157.215 108.296 158.71 109.79C162.102 113.182 166.703 115.088 171.5 115.088C176.297 115.088 180.898 113.182 184.29 109.79C185.542 108.538 186.592 107.122 187.418 105.591C189.766 101.24 193.596 97 198.54 97Z",
    fill: "#221725"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_diiii_397_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 190.5C164 179.494 159.628 168.938 151.845 161.155C144.062 153.372 133.506 149 122.5 149C111.494 149 100.938 153.372 93.1551 161.155C85.3723 168.938 81 179.494 81 190.5L122.5 190.5H164Z",
    fill: "url(#paint1_linear_397_3120)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_di_397_3120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.912 67.9976C181.329 67.9976 183.853 68.6576 185.484 69.9778C187.192 71.298 188.047 73.3947 188.047 76.268C188.047 79.2189 187.231 81.3933 185.6 82.7911C183.97 84.1113 181.407 84.7714 177.912 84.7714H131.319C128.445 84.7714 126.154 83.9171 124.446 82.2087C122.815 80.5003 122 78.3647 122 75.802C122 73.2394 122.893 70.7155 124.679 68.2305L160.556 19.4235H132.367C128.872 19.4235 126.271 18.7634 124.562 17.4432C122.932 16.0454 122.116 13.9487 122.116 11.153C122.116 8.2021 122.932 6.06654 124.562 4.74638C126.271 3.34857 128.872 2.64966 132.367 2.64966H177.097C179.893 2.64966 182.106 3.50388 183.737 5.21232C185.445 6.84311 186.299 8.93983 186.299 11.5025C186.299 14.1428 185.406 16.7055 183.62 19.1905L147.743 67.9976H177.912Z",
    fill: "url(#paint2_linear_397_3120)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.241 52.9543C241.01 52.9543 243.055 53.4892 244.377 54.559C245.761 55.6288 246.454 57.3279 246.454 59.6562C246.454 62.0475 245.793 63.8095 244.471 64.9422C243.15 66.012 241.073 66.5469 238.241 66.5469H200.484C198.156 66.5469 196.3 65.8547 194.915 64.4703C193.594 63.0858 192.933 61.3553 192.933 59.2787C192.933 57.202 193.657 55.1568 195.104 53.1431L224.177 13.5926H201.334C198.502 13.5926 196.394 13.0577 195.01 11.9879C193.688 10.8552 193.027 9.1561 193.027 6.89067C193.027 4.49939 193.688 2.76886 195.01 1.69907C196.394 0.566358 198.502 0 201.334 0H237.581C239.846 0 241.64 0.692215 242.961 2.07664C244.345 3.39814 245.038 5.09721 245.038 7.17385C245.038 9.31342 244.314 11.3901 242.867 13.4038L213.794 52.9543H238.241Z",
    fill: "url(#paint3_linear_397_3120)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iii_397_3120",
    x: -11,
    y: -24,
    width: 278,
    height: 326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 21,
    dy: 73
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.682806 0 0 0 0 0.0652778 0 0 0 0 0.783333 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.943639 0 0 0 0 0.223611 0 0 0 0 0.958333 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_397_3120",
    result: "effect2_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11,
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.766722 0 0 0 0 0.693056 0 0 0 0.68 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3120",
    result: "effect3_innerShadow_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_397_3120",
    x: -15,
    y: 58,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_397_3120",
    x: 114,
    y: 58,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5,
    result: "effect1_foregroundBlur_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_397_3120",
    x: 40.8352,
    y: 97,
    width: 67.5017,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_397_3120",
    x: 137.835,
    y: 97,
    width: 67.5017,
    height: 34.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_diiii_397_3120",
    x: 47.6667,
    y: 121.667,
    width: 149.667,
    height: 108.167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.6667
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0298758 0 0 0 0 0.0216858 0 0 0 0 0.0308333 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3120",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -34
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.59259
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17328 0 0 0 0 0.125777 0 0 0 0 0.178833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -40
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2963
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.119503 0 0 0 0 0.086743 0 0 0 0 0.123333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_397_3120",
    result: "effect3_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect4_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_397_3120",
    result: "effect4_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 26.45,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect5_innerShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9.2,
    dy: -31
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462111 0 0 0 0 0.203767 0 0 0 0 0.504167 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_innerShadow_397_3120",
    result: "effect5_innerShadow_397_3120"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_di_397_3120",
    x: 100.635,
    y: -3.36488,
    width: 151.184,
    height: 111.501,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.68244
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_397_3120"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_397_3120",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.21499
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.85996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.293755 0 0 0 0 0.0123844 0 0 0 0 0.891667 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_397_3120"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_397_3120",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109 16) rotate(86.5167) scale(230.426)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.576389,
    stopColor: "#FFBB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC907"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_397_3120",
    x1: 122.5,
    y1: 149,
    x2: 122.5,
    y2: 232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#201721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1F2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_397_3120",
    x1: 155.023,
    y1: 2.64966,
    x2: 155.168,
    y2: 84.7108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F46EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_397_3120",
    x1: 219.693,
    y1: 5.63308e-9,
    x2: 219.811,
    y2: 66.4978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F46EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43BBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_397_3120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 246,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepingFace);
export default __webpack_public_path__ + "static/media/sleeping-face.5dd9ee33117f3861e810e6e0dca45ea4.svg";
export { ForwardRef as ReactComponent };